import {
  apiRequest,
  apiGet as apiGetClient,
  apiPost as apiPostClient,
  apiPut as apiPutClient,
  apiDelete as apiDeleteClient,
  apiPatch as apiPatchClient,
} from './apiClient';

// Re-export convenience methods from apiClient
// These are the RECOMMENDED imports for new code
export { apiRequest, ERROR_CODES } from './apiClient';
export { setAuthContextGetter } from './apiClient';

// Legacy exports - for backward compatibility with existing code
export const apiGet = (path, options = {}) =>
  apiGetClient(path, options);

export const apiPost = (path, body, options = {}) =>
  apiPostClient(path, body, options);

export const apiPut = (path, body, options = {}) =>
  apiPutClient(path, body, options);

export const apiDelete = (path, options = {}) =>
  apiDeleteClient(path, options);

export const apiPatch = (path, body, options = {}) =>
  apiPatchClient(path, body, options);

// Fallback for any direct apiFetch() calls (legacy)
export async function apiFetch(path, options = {}) {
  return apiRequest(path, options);
}
